import styled from 'styled-components';

import Media from '../../../../utils/Media';

export const StyledCategory = styled.span`
  display: block;
`;

export const StyledImage = styled.div`
  bottom: 0;
  display: block;
  background-size: cover;
  background-color: ${props => props.theme.colors.muted};

  ${Media({
    flex: [null, null, '1 1 0'],
    height: ['331px', null, 'auto', '564px'],
    marginLeft: ['-1rem', '-1rem', '0', '-58px'],
    marginRight: ['-1rem', '-1rem', '0', '-58px'],
    position: [null, null, null, 'absolute'],
    top: ['174px', null, '59px'],
    width: ['calc(100% + 2rem)', 'auto', 'auto', `calc(100% + 58px + 58px)`],
    zIndex: ['-1'],
  })}
`;

export const StyledTextBox = styled.div`
  background-color: ${props => props.theme.ctaBanner.focusImage.backgroundColor};
  color: ${props => props.theme.ctaBanner.focusImage.color};

  &.left {
    ${Media({
      left: ['0', null, null, '113px'],
    })}
  }
  &.right {
    ${Media({
      right: ['0', null, null, '113px'],
    })}
  }

  ${Media({
    flex: [null, null, '1 1 0'],
    marginLeft: ['-1rem', '-1rem', '0', '0px'],
    marginRight: ['-1rem', '-1rem', '0', '0px'],
    maxWidth: [null, null, null, '533px'],
    paddingBottom: ['2.625rem', null, null, '5rem'],
    paddingLeft: ['1.5625rem', null, null, '5rem'],
    paddingRight: ['1.5625rem', null, null, '5rem'],
    paddingTop: ['2.625rem', null, null, '4.625rem'],
    position: [null, null, null, null, 'absolute'],
    width: [null, null, null, '100%'],
  })}
`;

export const StyledTextBoxDescription = styled.div`
  font-size: 1rem;
  line-height: 1.75;
  color: ${props => props.theme.ctaBanner.focusImage.color};

  p,
  ul,
  ol,
  li {
    font-size: 1rem;
    line-height: 1.75;
    color: ${props => props.theme.ctaBanner.focusImage.color};
  }

  & ul li::before {
    background-color: ${props => props.theme.ctaBanner.focusImage.color} !important;
  }

  ${Media({
    marginBottom: ['2rem', null, '2.5rem'],
  })}
`;

export const StyledTextBoxTitle = styled.h3`
  color: ${props => props.theme.ctaBanner.focusImage.titleColor ?? props.theme.colors.text};
  font-size: 2rem;
  font-weight: ${props => props.theme.ctaBanner.focusImage.titleFontWeight || 'normal'};
  margin: 0;
  word-break: break-word;
  font-family: ${props => props.theme.fonts.heading};

  a {
    color: ${props => props.theme.colors.darkGray};
    text-decoration: none;
  }

  ${Media({
    fontSize: ['1.5rem', null, '2rem'],
    marginBottom: ['1rem', null, '1rem'],
  })}
`;

export const StyledTextBoxWrapper = styled.div`
  overflow: hidden;
  position: relative;
  margin: 0 auto;

  ${Media({
    display: [null, null, 'flex', 'block'],
    flexDirection: [null, null, 'row-reverse'],
    height: [null, null, null, null, `calc(564px + 59px)`],
    marginLeft: [null, null, '-2rem', '0'],
    marginRight: [null, null, '-2rem', '0'],
  })}
`;
